import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { ConfigurationService } from 'src/app/core/configuration.service';
import { DateService } from 'src/app/core/date.service';
import { Period } from 'src/app/core/period.enum';

@Injectable({
  providedIn: 'root'
})
export class EventsDisplayGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private dateService: DateService,
    private configurationService: ConfigurationService,
    private router: Router
    ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (this.authService.isAdmin() || this.authService.isRedactor()) {
        return true;
      }
      const period = this.configurationService.getPeriod();
      if (period === Period.duringEdition) {
        return true;
      }

      this.router.navigate(['/']);
  }
}
